import React, { useState, useEffect, useRef } from 'react';
import ProfileRow from './ProfileRow';
import CanvasItem from './avwapp.chart';
import { fetchData } from './service/avwapp.service';
import { host } from './env';
import { QualityStock } from './QualityStocks';
import StockPopupButton from './StockPopupButton';

type QualityStocksProps = {};

const SmallCapLeaders: React.FC<QualityStocksProps> = ({}) => {
  const [smallCapLeadersData, setSmallCapLeadersData] = useState<
    QualityStock[]
  >([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    handleSmallCapLeaders();
  }, []);

  const fetchFromApi = async () => {
    try {
      const result = await fetchData(`${host}/smallCapLeaders`);
      setSmallCapLeadersData(result);
    } catch (err) {
      setError('Failed to fetch small cap leaders stocks');
      console.log('err', err);
    } finally {
    }
  };

  const handleSmallCapLeaders = async () => {
    fetchFromApi();
  };

  function formatMarketCap(value: number): string {
    if (value >= 1_000_000_000) {
      return (value / 1_000_000_000).toFixed(2) + 'B';
    } else if (value >= 1_000_000) {
      return (value / 1_000_000).toFixed(2) + 'M';
    } else if (value >= 1_000) {
      return (value / 1_000).toFixed(2) + 'K';
    } else {
      return value.toString();
    }
  }

  function formatPercentage(decimal: number): string {
    return (decimal * 100).toFixed(1) + '%';
  }

  return (
    <div>
      <h3 className="avwapp-subtitle">
        Small Cap Leaders based on RS &gt; 75 AND 21 day atr% &lt; 20% AND
        volume &gt; 20,000 AND marketcap &lt; 300,000,000
      </h3>
      <table className="qualityStocks">
        <thead>
          <tr>
            <td>Symbol</td>
            <td>Rs rating</td>
            <td>21d atr %</td>
            <td>avg volume</td>
            <td>Market cap</td>
          </tr>
        </thead>

        {smallCapLeadersData.map((item: QualityStock) => (
          <tr>
            <td><StockPopupButton symbol={item.symbol} /></td>
            <td>{item.rsRating}</td>
            <td>{formatPercentage(item.atr21)}</td>
            <td>{formatMarketCap(item.volume)}</td>
            <td>{formatMarketCap(item.marketCap)}</td>
          </tr>
        ))}
      </table>
    </div>
  );
};

export default SmallCapLeaders;
